import {NOT_SELECTED} from '../enum';

function isSelected(index) {
    return index > NOT_SELECTED;
}

function getResultByIndex(results, destinationIndex) {
    // set first item as default
    let destination = results[0];
    if (isSelected(destinationIndex)) {
        destination = results[destinationIndex];
    }
    return {
        destination
    };
}

export function getCurrentDestinationIndex(index) {
    return index === NOT_SELECTED ? 0 : index;
}

export function getSelectedResult(results, destinationIndex) {
    if (results && results.length && results.length > 0) {
        return getResultByIndex(results, destinationIndex);
    }
    return {};
}

function previousIndex(results, destinationIndex) {
    const selectDestinationIndex =
        destinationIndex > 0 ? destinationIndex - 1 : results.length - 1;
    return {selectDestinationIndex};
}
/* eslint-enable complexity */

function nextIndex(results, destinationIndex) {
    const selectDestinationIndex =
        destinationIndex < results.length - 1 ? destinationIndex + 1 : 0;
    return {
        selectDestinationIndex
    };
}

export function getPreviousResultIndex(results, destinationIndex) {
    return previousIndex(results, destinationIndex);
}

export function getNextResultIndex(results, destinationIndex) {
    if (destinationIndex === NOT_SELECTED) {
        return {
            selectDestinationIndex: 0
        };
    }
    return nextIndex(results, destinationIndex);
}
